import { useQuotationsListStore } from '@common/store/group-displacement-list-store';
import { Input, Stack, Text } from '@mantine/core';
import { isEmpty, isNil } from 'lodash-es';
import { useTranslation } from 'react-i18next';

export function FilterByNrOfRooms() {
  const { t } = useTranslation();
  const paramKey = 'number_of_rooms';
  const { params, setParams, setFilters } = useQuotationsListStore();

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    setFilters({
      [paramKey]: isNil(event.target.value) ? undefined : Number(event.target.value)
    });
    setParams({ [paramKey]: isNil(event.target.value) ? undefined : Number(event.target.value) });
  }

  return (
    <Stack gap="0">
      <Text size="sm">{t('Number of Rooms')}</Text>
      <Input
        variant="filled"
        placeholder={String(t('All rooms'))}
        value={params[paramKey] ?? ''}
        onChange={handleChange}
      />
    </Stack>
  );
}
